// export const mapProductsByCategory = (products) => {


//     const categories = {};
  
//     products.forEach((product) => {
  
//       // const categoryKey = product.categoryEN; 
//        const categoryKey = product.category; 
//       if (!categories[categoryKey]) {
//         categories[categoryKey] = [product];
//       } else {
//         categories[categoryKey].push(product);
//       }
//     });
  
//     return categories;
//   };
  
  
  export const mapProductsByCategory = (products) => {
  const categories = {};
  products.forEach(product => {
    // Always use the ENGLISH key for mapping!
    const key = product.categoryEN || product.category;
    if (!categories[key]) categories[key] = [];
    categories[key].push(product);
  });
  return categories;
};